define(
  'modules/navigation',
  [
    'jquery',
    'modules/tracking',
    'modules/spin-loader',
    'modules/utils',
    'modules/camera',
    'modules/animation'
  ],
  function (
    $,
    M_Tracking,
    M_SpinLoader,
    M_Utils,
    M_Camera,
    M_Animation
  ) {
    'use strict';

    var classes = {
      isHidden: 'is--hidden',
      isActive: 'is--active'
    };
    var selectors = {
      navigationControls: '.js-navigation-controls',
      exteriorControl: '.js-exterior-control',
      interiorControl: '.js-interior-control'
    };
    var state = {
      isVisible: false,
      hasBeenShown: false
    };
    var $navigationControls
      , $exteriorControl
      , $interiorControl;


    function init () {
      getElems();
      bindEvents();
    }

    function getElems () {
      $navigationControls = $(selectors.navigationControls);
      $exteriorControl = $(selectors.exteriorControl);
      $interiorControl = $(selectors.interiorControl);
    }

    function bindEvents () {
      $exteriorControl.on('click', onExteriorControlClick);
      $interiorControl.on('click', onInteriorControlClick);
    }

    function showControls (show) {
      state.isVisible = show;
      show ? $navigationControls.removeClass(classes.isHidden) : $navigationControls.addClass(classes.isHidden);

      if (show && !state.hasBeenShown) {
        M_Animation.playSequence('controlButtons');
        state.hasBeenShown = true;
      }
    }

    function onExteriorControlClick (e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      M_Utils.triggerEvent('nx-show-nav-exterior');
      M_Tracking.trackEvent('click-cta', 'Exterior');
    }

    function onInteriorControlClick (e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      M_Utils.triggerEvent('nx-show-nav-interior');
      M_Tracking.trackEvent('click-cta', 'Interior');
    }

    function setActiveControl (control) {
      switch (control) {
        case 'exterior':
          $interiorControl.removeClass(classes.isActive);
          $exteriorControl.addClass(classes.isActive);
          break;
        case 'interior':
          $exteriorControl.removeClass(classes.isActive);
          $interiorControl.addClass(classes.isActive);
          break;
        default:
          $exteriorControl.removeClass(classes.isActive);
          $interiorControl.removeClass(classes.isActive);
          break;
      }
    }

    return {
      init: init,
      showControls: showControls,
      setActiveControl: setActiveControl
    }
});

